module.exports = __webpack_public_path__ + "static/media/corporate-services-img79.650d867c.jpg";